import React from "react";

const Headers = () => {

    const generic = (tag, value, props = {}) => {
        let children
        if(value === 'date_trunc') {
            children = "date/time"
        } else {
            children = value.replaceAll('_', ' ')
        }
        return React.createElement(tag, props, children)
    }


    return {
        generic :       generic
    }
}

export default Headers